//Base SymbolLookup ============================================================

//these must be defined ouside the (function($){
function SymbolLookup() {
	this.init.apply(this,arguments);
}
function QuickLookup($root, opts) {
	this.init($root,opts || true);
}

function ExchangeLookup() {
	this.init.apply(this, arguments);
}

(function($) {

	SymbolLookup.prototype.init = function(rootEl, opts) {
		var $root = $(rootEl || "#wsod_symbolLookup");
		this.$root = $root;
		this.$search = $root.find("div.btn-med");
		this.$recent = $root.find("div.btn-drop");
		this.$text = $root.find("input").eq(0);

		if (opts) {
			if (opts.apiPath) {
				this.apiPath = opts.apiPath;
			}
			this._isWl = true;
			this.opts = opts;
		}
		if ($root.hasClass("globalSearcher")) {
			this.isGlobalSearcher = true;
		}
		this.initEvents();

		if (document.URL.indexOf("key=") != -1) {
			wsod.inputFocus.call(this.$text);
			this.$text.trigger('focus');
		}
	};

    SymbolLookup.prototype.initEvents = function() {
		this.$root.click(wsod.event(this, this.handleClick));
		this.$text.keyup(wsod.event(this, this.handleKeyUp));
	};
    SymbolLookup.prototype.removeEvents = function() {
		if (this.bodyClick) {
			$(document.body).unbind("click", this.bodyClick);
		}
		this.bodyClick = null;
	};

    SymbolLookup.prototype.clean = function() {
		wsod.closeAllControls(this.$root);
	};

    SymbolLookup.prototype.handleClick = function(event) {
		var target = event.target;
		var click = $(target);
		if (click.closest("div.btn-drop").length) { //recent searches button
			this.toggleDrop();
		} else if (click.closest('.wsod_globalRecent .cancel').length) {
			this.toggleDrop();
		} else if (click.closest('.wsod_globalSearch .cancel').length) {
			this.clean();
		} else if (click.closest("div.btn-med").length) { //search button
			this.lookupStart();
		}
	};
    SymbolLookup.prototype.handleKeyUp = function(e) {
		var $searchTable = this.$root.find(".wsod_globalSearch");
		var $recentTable = this.$root.find(".wsod_globalRecent");

		if ($recentTable.hasClass("hide")) {
			$resultsTable = $searchTable;
		} else {
			$resultsTable = $recentTable;
		}

		var $selectedRow = $resultsTable.find("table tr.selected");
		var code = e.which; //jquery normalized keycode
		var self = this;

		this.$root.find(".wsod_symbolLookupSearch a").focus(function() { //this is for tabbing out of the dropdown search
			self.clean();
		});

		if (code == 13) //enter key
		{
			if (this._cache[this.$text.val()]) //check if the symbol typed in exists in the cache before looking it up
			{
				//check if FNZ link or callback with onclick event
				var linkAttr = $selectedRow.find("td.col-name a").attr("onclick");
				if (typeof linkAttr !== "undefined" && linkAttr !== false) {
					if ($selectedRow.length == 0) {
						$selectedRow = $(".wsod_globalSearch").find("tr").first();
					}

					$selectedRow.find("td.col-name a").click();

				} else {
					if ($selectedRow.length == 0) {
						$selectedRow = $(".wsod_globalSearch").find("tr").first();
					}

					window.location = $selectedRow.find("td.col-name a").attr("href");
				}
			}
			else //if user types in symbol and presses enter before table is finished loading
			{	 //TODO: Add previous page to url through GET so duplicate symbols for international can be handled correctly
				var sym = this.$root.find(".custom-input input").val();

				// because the user presses enter before the popularity key has been resolved, we won't be able to increase popularity rank
				// TODO look into resolving key for first result for this case and populating the key, rather than setting it to "1"
				var lookup = "key=1"; //TT0101787 //TT0122715

				if($("#wsod_symbolLookup.drop-input-search .wsod_globalSearch .noresults").length > 0)
				{
					//do nothing since the "Invalid Code, please try again." message has appeared
					//NOTE: the noresults box DOESN'T get cached - so check needs to be here rather than above
				}
				else
				{
					if(typeof wsod_toresearch != "undefined")
					{
						wsod.location(wsod_toresearch() + sym + lookup);
					}
					else
					{
						wsod.reload({symbol:sym,key:"1"});
					}
				}
			}
		}
		else if (code == 38) //up arrow key
		{
			this.moveSelection(1, $resultsTable);
		}
		else if (code == 40) //down arrow key
		{
			this.moveSelection(0, $resultsTable);
		}
		else {
			this.lookupStart();
		}
	};

    SymbolLookup.prototype.moveSelection = function(dir, resultsTable) {
		$resultsTable = $(resultsTable);
		var $selectedRow = $resultsTable.find("table tr.selected");
		var $rows = $resultsTable.find("table tr");
		$selectedRow.removeClass("selected hasMoved");

		if (dir == 1) {
			$selectedRow.prev().addClass("selected hasMoved");
		}
		else if (dir == 1 && $selectedRow.prev().length == 0) {
			$rows.last().addClass("selected hasMoved");
		}
		else if (dir == 0 && $selectedRow.next().length == 0) {
			$rows.first().addClass("selected hasMoved");
		}
		else {
			$selectedRow.next().addClass("selected hasMoved");
		}
	};

    SymbolLookup.prototype.toggleDrop = function(isSearch) {
		var $r = this.$root;
		if ($r.hasClass("drop-input-load")) { return; } //we're doing a search so don't do anything
		var recentOpen = $r.hasClass("drop-input-recent"); //recent dropdown open?
		this.$result = this.$root.find("div.results .wsod_globalRecent");

		this.selectionEvents();
		this.clean();
		if (isSearch) {
			$r.addClass("drop-input-search");
		} else if (!recentOpen) {
			$r.addClass("drop-input-recent");
		}
	};

    SymbolLookup.prototype.selectionEvents = function() {
		var $dropDown = this.$root.find("div.results");
		$rows = $dropDown.find("table tr");

		$rows.eq(0).addClass("selected");

		$dropDown.mouseover(function(e) {
			var $tr = $(e.target).closest("tr");
			if ($tr.length) {
				$tr.addClass("selected");
			}
		});
		$dropDown.mouseout(function(e) {
			var $tr = $(e.target).closest("tr");
			if ($tr.length) {
				$tr.removeClass("selected");
			}
		});
		$dropDown.click(function(e) {
			var $tr = $(e.target).closest("tr");

			if ($tr.hasClass("selected")) {
				var $trLink = $tr.find("td.col-name a");

				//if the intellisense link has an onclick event (aka Options and Warrants) execute that click event
				if ($trLink.attr("onclick") != null && typeof $trLink !== "undefined" && $trLink !== false) {
					$trLink.click();
				}
				else { //otherwise run it's href
					window.location = $trLink.attr("href");
				}
			}
		});
	};

    SymbolLookup.prototype._cache = {};

	SymbolLookup.prototype.lookupStart = function(e, el) {
        this.abort(this._call);

        var query = this.$text.val();

		if (query == "" || query == wsod.inputDefault(this.$text[0])) {
			this.clean(); return;
		}

        var inputs = {
            query: query,
            wl: (this._isWl ? 1 : 0),
            strain: (this.isGlobalSearcher ? "AllWithSecurities" : "All") //AllWithSecurities strain here so securities are included in global search but no where else
        };

        if (this.opts) { $.extend(inputs, this.opts); }

		this.beforeLoad(inputs); //portfolio uses inputs parameter

		this._call = wsod.load(inputs
			, this.apiPath
			, this.lookupReturn
			, this.lookupReturn
			, this
		);
	};

    SymbolLookup.prototype.abort = function(call) {
		if (call) {
			try { call.abort(); }
			catch (e) { $.log(e); }
		}
	};

    SymbolLookup.prototype.apiPath = "Api/SymbolLookup";

	if ($("#WSOD_WidgetHeader").length > 0) //TODO: change this to use wsod_ajaxPath()...however it is undefined for some reason even though it is clearly written on page load
	{
		SymbolLookup.prototype.apiPath = "Widget/SymbolLookup";
	}

	SymbolLookup.prototype.beforeLoad = function() {
		wsod.show(this.$root.find(".wsod_globalSearchLoader"));
		this.$root.addClass("drop-input-load");
	};

    SymbolLookup.prototype.cacheResult = function(result) {
		var query = result.query;
		var status = result.Status;

		if (status == "1" && query && !this._cache[query]) {
			this._cache[query] = result.html;
		}
	};

    SymbolLookup.prototype.lookupReturn = function(result, status) {
		this.$root.removeClass("drop-input-load");
		wsod.hide(this.$root.find(".wsod_globalSearchLoader"));

		if (!result || !result.html) {
			return; //no html
		}

		this.$root.find(".wsod_globalSearch").replaceWith(result.html);
		this.toggleDrop(true);
		this.cacheResult(result);
	};

    //QuickLookup ==================================================================
	$.extend(QuickLookup.prototype, SymbolLookup.prototype);
	QuickLookup.prototype.base = SymbolLookup.prototype;
	QuickLookup.prototype._cache = {};

	QuickLookup.prototype.clean = function() {
		this.toggleDrop();
	};
    QuickLookup.prototype.toggleDrop = function(dontHide) {
		this.$result.removeClass("noresults").empty();
		if (!dontHide) {
			this.$result.addClass("hide");
		}
	};
    QuickLookup.prototype.initEvents = function() {
		this.$result = this.$root.find("div.results");

		var _this = this;
		this.base.initEvents.call(this);

		this.$result.mouseover(function(e) {
			var $li = $(e.target).closest("li");
			if ($li.length) {
				$li.addClass("selected");
			}
		});
        this.$result.mouseout(function(e) {
			var $li = $(e.target).closest("li");
			if ($li.length) {
				$li.removeClass("selected");
			}
		});
        this.$root.focusout(wsod.event(this, this.handleFocusOut));
	};

    QuickLookup.prototype.handleKeyUp = function(e) {
		var code = e.which; //jquery normalized keycode
		if (13 == code) {
			this.clickAdd(this.$search);
		} else {
			this.lookupStart();
		}
	};

    QuickLookup.prototype.handleClick = function(event) {
		//if (this._isSearching) /*|| (!isNew && wsod_wl.createdg))*/ { return; }
		var $click = $(event.target);
		var $el = null;

		//clicked add, update watchlist
		if (($el = $click.closest("div.btn", this.$root)).length) {
			var $inputField = this.$text;
			var symbol = $inputField.val();
			$inputField.attr("sym", symbol);
			$inputField.val(symbol);
			this.setSelectedLookup($inputField);
			this.toggleDrop();
			this.clickAdd(this.$search);
		}

		//clicked on a result, populate selection
		else if (($el = $click.closest("div.results li")).length) {
			if (!$el) { return; }
			this.setSelectedLookup($el);
			this.toggleDrop();
			this.clickAdd(this.$search); //ISS140688 now with auto-action
		}

		//clicked somewhere else, hide results
		else {
			this.toggleDrop();
		}
	};
    QuickLookup.prototype.handleFocusOut = function(event) {
		// only focus out when not in process of selecting a result
		if (this.$result.find('.selected').html() === null) {
			this.clean();
//			var $text = this.$text;
//			$text.val($text.attr('defaultValue'));
		}
	};
    QuickLookup.prototype.clickAdd = function($btn) {
		//override to set add button bevavior
	};

    QuickLookup.prototype.clearSelectedLookup = function() {
		var $i = this.$text;
		$i.attr("issueid", "");
		$i.attr("title", "");
		$i.attr("sym", "");
		$i.attr("entityxid", "");
		$i.attr("value", "");
	};

    QuickLookup.prototype.setSelectedLookup = function($el) {
		var $i = this.$text;
		$i.val($el.attr("sym"));
		$i.attr("issueid", $el.attr("issueid"));
		$i.attr("title", $el.attr("com"));
		$i.attr("sym", $el.attr("sym"));
		$i.attr("entityxid", $el.attr("entityxid"));
	};

    QuickLookup.prototype.lookupReturn = function(result, status) {
		var $r = this.$result;
		this.toggleDrop(true);
		if (status != "1") {
			$r.addClass("noresults");
			$r.empty().append("No results were found");
			return;
		}

		this.clearSelectedLookup();
		$r.empty().append(result.html);
		this.cacheResult(result);
	};

    QuickLookup.prototype.beforeLoad = function() {
		this.$result.empty();
		this.$result.removeClass("hide");
		//this.showLoader();
	};

    QuickLookup.prototype.showLoader = function() {
		var $r = this.$result;
		var $loader = null;
		if($.create != undefined && (typeof $.create === "function")) {
			$loader = $.create("div", { "class": "loader loaderImg l-s loaderRow" });
		} else {
			$loader = $("<div class=\"loader loaderImg l-s loaderRow\"></div>");
		}
		$r.empty().append($loader);
		$r.removeClass("hide");
	};

    //==================Exchange Lookup=================================================

	ExchangeLookup.prototype.init = function (rootEl, opts) {
		var $root = $(rootEl || "#wsod_exchangeLookup");
		this.$root = $root;
		this.$recent = $root.find("div.btn-drop");
		this.cachedHtml = "";

		if (opts) {
			if (opts.apiPath) {
				this.apiPath = opts.apiPath;
			}
			this._isWl = true;
			this.opts = opts;
		}
		this.initEvents();
	};

    ExchangeLookup.prototype.initEvents = function () {
		this.$root.click(wsod.event(this, this.handleClick));
		this.$root.keyup(wsod.event(this, this.handleKeyUp));
	};
    ExchangeLookup.prototype.removeEvents = function () {
		if (this.bodyClick) {
			$(document.body).unbind("click", this.bodyClick);
		}
		this.bodyClick = null;
	};

    ExchangeLookup.prototype.clean = function () {
		wsod.closeAllControls(this.$root);
	};

    ExchangeLookup.prototype.handleClick = function (event) {
		var target = event.target;
		var click = $(target);
		if (click.closest("div.btn-drop").length) { //recent searches button
			this.lookupStart();
		} else if (click.closest('.wsod_globalExchangeDropdown .cancel').length) {
			this.toggleDrop();
		}
	};
    ExchangeLookup.prototype.handleKeyUp = function (e) {
		var $searchTable = this.$root.find(".wsod_globalExchangeDropdown");
		var $recentTable = this.$root.find(".wsod_globalExchangeDropdown");

		if ($recentTable.hasClass("hide")) {
			$resultsTable = $searchTable;
		} else {
			$resultsTable = $recentTable;
		}

		var $selectedRow = $resultsTable.find("table tr.selected");
		var code = e.which; //jquery normalized keycode
		var self = this;

		this.lookupStart();
	};

    ExchangeLookup.prototype.moveSelection = function (dir, resultsTable) {
		$resultsTable = $(resultsTable);
		var $selectedRow = $resultsTable.find("table tr.selected");
		var $rows = $resultsTable.find("table tr");
		$selectedRow.removeClass("selected hasMoved");

		if (dir == 1) {
			$selectedRow.prev().addClass("selected hasMoved");
		}
		else if (dir == 1 && $selectedRow.prev().length == 0) {
			$rows.last().addClass("selected hasMoved");
		}
		else if (dir == 0 && $selectedRow.next().length == 0) {
			$rows.first().addClass("selected hasMoved");
		}
		else {
			$selectedRow.next().addClass("selected hasMoved");
		}
	};

    ExchangeLookup.prototype.toggleDrop = function () {
		var $r = this.$root;
		if ($r.hasClass("drop-input-load")) { return; } //we're doing a search so don't do anything
		var exchangeSearchOpen = $r.hasClass("drop-input-searchExchange");
		this.$result = this.$root.find("div.results .wsod_globalExchangeDropdown");

		this.selectionEvents();
		this.clean();
		if (!exchangeSearchOpen) {
			$r.addClass("drop-input-searchExchange");
		}
		else {
			$r.removeClass("drop-input-searchExchange");
		}
	};

    ExchangeLookup.prototype.selectionEvents = function () {
		var $dropDown = this.$root.find("div.results");
		$rows = $dropDown.find("table tr");

		$rows.eq(0).addClass("selected");

		$dropDown.mouseover(function (e) {
			var $tr = $(e.target).closest("tr");
			if ($tr.length) {
				$tr.addClass("selected");
			}
		});
		$dropDown.mouseout(function (e) {
			var $tr = $(e.target).closest("tr");
			if ($tr.length) {
				$tr.removeClass("selected");
			}
		});
		$dropDown.click(function (e) {
			var $tr = $(e.target).closest("tr");
			if ($tr.hasClass("selected")) {
				window.location = $tr.find("td a").attr("href");
			}
		});
	};

    ExchangeLookup.prototype._cache = {};
	ExchangeLookup.prototype.lookupStart = function (e, el) {
		this.clean();
		this.abort(this._call);
		var companyName = $("#wsod_maincompanyName").val();
		var symbol = $("#wsod_mainsymbol").val();
		var issueId = $("#wsod_mainissueID").val();

		var inputs = { companyName: companyName, issueId: issueId, sym: symbol, strain: "AllWithSecurities" }; //AllWithSecurities strain here so securities are included in global search but no where else
		if (this.opts) { $.extend(inputs, this.opts); }
		this.beforeLoad(inputs); //portfolio uses inputs parameter
		if (this.cachedHtml.length > 0) {
			this.lookupReturn({ html: this.cachedHtml }, "1");
			return;
		}

		this._call = wsod.load(inputs
			, this.apiPath
			, this.lookupReturn
			, this.lookupReturn
			, this
		);
	};

    ExchangeLookup.prototype.abort = function (call) {
		if (call) {
			try { call.abort(); }
			catch (e) { $.log(e); }
		}
	};

    ExchangeLookup.prototype.apiPath = "Api/ExchangeLookup";

	ExchangeLookup.prototype.beforeLoad = function () {
		wsod.show(this.$root.find(".wsod_globalExchangeLoader"));
		this.$root.addClass("drop-input-load");
	};

    ExchangeLookup.prototype.cacheResult = function (result) {
		var html = result.html;
		var status = result.Status;
		if (status == "1" && html && !this._cache[html]) {
			this.cachedHtml = result.html;
		}
	};

    ExchangeLookup.prototype.lookupReturn = function (result, status) {
		this.$root.removeClass("drop-input-load");
		wsod.hide(this.$root.find(".wsod_globalExchangeLoader"));
		if (!result || !result.html) {
			return;
		}

		this.$root.find(".wsod_globalExchangeDropdown").replaceWith(result.html);
		this.toggleDrop();
		this.cacheResult(result);
	};

})(jQuery);
